export default {
    methods: {
        copyObjByVal(source) {
            return JSON.parse(JSON.stringify(source));
          },
        getValues(object) {
        // use a polyfill in case Object.values is not supported by current browser
            return Object.values ? Object.values(object) : Object.keys(object).map(key => object[key]);
        }
    },
  };